import React from 'react';
import { Skeleton } from 'antd';
import {  FormattedMessage } from 'react-intl';
import styles from './NotesCard.module.scss';
import NotesCardItem from './NotesCardItem';
import messages from '../../Containers/ManualSearchV2/ManualSearchMessages';

function NotesCard(props) {
  const {
    allNotes,
    onDelete,
    noteFetchApiStatus,
    onEdit,
    noteDeleteApiStatuses,
    onTagChange,
    onLoadMore,
    onTagAdd,
    suggestedTags,
    totalSuggestedTagsCount,
    tagCloseApiStatus,
    onTagClose,
    setNotification,
    suggestedTagsApiStatus,
  } = props;
  const [isSeeMore, setSeeMore] = React.useState(false);
  const handleButtonClick = () => setSeeMore(!isSeeMore);
  const buttonName = isSeeMore ? <FormattedMessage {...messages.seeMoreLabel} /> : <FormattedMessage {...messages.seeLessLabel} />;
  return (
    <div>
      {allNotes?.length ? (
        <div role="presentation" className={styles.seeButton} onClick={handleButtonClick}>
          {buttonName}
        </div>
      ) : null}
      {!isSeeMore ? (
        <Skeleton loading={noteFetchApiStatus === 'INPROGRESS'} avatar paragraph={{ rows: 4 }}>
          {(allNotes || []).map(note => (
            <NotesCardItem
              key={note.Id}
              note={note}
              onDelete={onDelete}
              onUpdateNote={onEdit}
              noteDeleteApiStatus={noteDeleteApiStatuses?.[note?.Id]}
              onTagChange={onTagChange}
              onTagLoadMore={onLoadMore}
              onTagAdd={onTagAdd}
              onTagClose={onTagClose}
              suggestedTags={suggestedTags}
              totalSuggestedTagsCount={totalSuggestedTagsCount}
              tagCloseApiStatus={tagCloseApiStatus}
              setNotification={setNotification}
              suggestedTagsApiStatus={suggestedTagsApiStatus}
            />
          ))}
        </Skeleton>
      ) : null}
    </div>
  );
}

export default NotesCard;
